import { __rest } from "tslib";
import * as React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
import SelectedFlights from '../SelectedFlights/SelectedFlights';
import { getSelectedExchangeFlights } from '@entities/exchange';
const ContentWithSelectedFlights = (_a) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    const { ContentWithSelectedFlights: theme } = useTheme('Widgets').Exchange;
    const selectedFlights = useSelector(getSelectedExchangeFlights);
    return (React.createElement("div", { className: cn(theme.root, className) },
        selectedFlights.length > 0 && (React.createElement(SelectedFlights, Object.assign({ className: theme.selectedFlights, selectedFlights: selectedFlights }, props))),
        children));
};
export default ContentWithSelectedFlights;
